import React, { useState, useEffect } from 'react';
import { Home, Dumbbell, ShoppingBag, Shield, Users, Calendar, UtensilsCrossed } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API } from '../utils/api';

export const BottomNav = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [macroflexConfig, setMacroflexConfig] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/macroflex`)
      .then(res => setMacroflexConfig(res.data))
      .catch(() => {});
  }, []);

  const navItems = [
    { icon: Home, label: 'Início', path: '/dashboard', testId: 'nav-home' },
    { icon: Dumbbell, label: 'Treinos', path: '/workouts', testId: 'nav-workouts' },
    { icon: ShoppingBag, label: 'Loja', path: '/shop', testId: 'nav-shop' },
    { icon: Users, label: 'Social', path: '/community', testId: 'nav-community' },
    { icon: Calendar, label: 'Calendário', path: '/calendar', testId: 'nav-calendar' },
  ];

  // Insert Macroflex before Calendário if enabled
  if (macroflexConfig?.enabled) {
    navItems.splice(4, 0, {
      icon: UtensilsCrossed,
      label: macroflexConfig.label || 'Dieta',
      path: '__external__',
      url: macroflexConfig.url || 'https://www.macroflex.com.br',
      testId: 'nav-macroflex',
    });
  }

  if (user?.role === 'admin') {
    navItems.push({
      icon: Shield,
      label: 'Admin',
      path: '/admin',
      testId: 'nav-admin',
    });
  }

  const handleClick = (item) => {
    if (item.path === '__external__') {
      window.open(item.url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(item.path);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-zinc-950/80 backdrop-blur-xl border-t border-white/10 z-50">
      <div className="flex items-center justify-around max-w-screen-xl mx-auto px-2 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.path !== '__external__' && location.pathname === item.path;

          return (
            <motion.button
              key={item.testId}
              onClick={() => handleClick(item)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg transition-colors ${
                isActive
                  ? 'text-neon-lime'
                  : 'text-zinc-400 hover:text-white'
              }`}
              whileTap={{ scale: 0.95 }}
              data-testid={item.testId}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};
